import type { DashboardMetrics } from '@parinaam-vms/shared';
import { apiGet, toQueryString } from './client';

/** `YYYY-MM-DD`, or '' for no bound. Both empty is all time. */
export type MetricsRange = { from?: string; to?: string };

/**
 * Everything the dashboard draws, in one request.
 *
 * One parameter, and only one: the window the period figures are computed over.
 * The scope note in `shared/src/metrics.ts` is where the line is drawn — a
 * window on when the work happened is admissible here; drill-down, grouping and
 * export are the reporting layer Plan D10 defers, and stay out.
 *
 * Empty strings are dropped by `toQueryString`, so an unset end sends nothing
 * rather than `?from=` — which the API would reject as a malformed date.
 */
export function fetchDashboardMetrics(range: MetricsRange = {}): Promise<DashboardMetrics> {
  return apiGet<DashboardMetrics>(`/metrics/dashboard${toQueryString(range)}`);
}
